import React from "react";
import { REPORT_PAGES_ROUTES } from "../../../../constants";
import { cveFiltered } from "../../../../store/vulnerabilitySlice";
import { LinkToReportTab } from "../../../common";
import { useReportDispatch } from "../../../hooks";
import ChangeCategoryCard from "./ChangeCategoryCard";
import styles from "./diffChanges.module.scss";
const VulnerabilityChanges = ({ vulnerabilitiesDiff, }) => {
    const dispatch = useReportDispatch();
    const added = vulnerabilitiesDiff
        .filter((change) => change.change !== "removed")
        .map((change, index) => (React.createElement(LinkToReportTab, { underline: "hover", key: change.current, id: `diff-modified-vulnerability-change-link-${index}`, to: REPORT_PAGES_ROUTES.VULNERABILITIES_ROUTE, className: styles["issue-link"], inline: true, onClick: () => dispatch(cveFiltered(change.current)), color: "link" }, change.current)));
    const removed = vulnerabilitiesDiff
        .filter((change) => change.change === "removed")
        .map((change) => React.createElement("strong", { key: change.previous }, change.previous));
    return (React.createElement(ChangeCategoryCard, { title: "Vulnerabilities", added: added, removed: removed }));
};
export default VulnerabilityChanges;
//# sourceMappingURL=VulnerabilityChanges.js.map